import { ProcessRmodel } from "./process.model"

export class LabelModel {
    name = ''
    process: ProcessRmodel | null = null
}